"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryOfProductFilterField = exports.Categories = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _reactRedux = require("react-redux");
var _AddFilterButton = require("./AddFilterButton");
var _ApplyAndCancelButtons = require("../sharedComponents/ApplyAndCancelButtons");
var _config = require("../../../../config");
var _TableFilters = require("../TableFilters");
var _excluded = ["appliedFilter", "allFilters", "setAllFilters"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "400px"
    },
    categoryFieldWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    categoryField: {
      display: "flex"
    },
    formControlLabel_1: {
      width: "100%",
      marginBottom: 0
    },
    formControlLabel_2: {
      marginBottom: 0
    },
    arrowButtonWrapper: {
      display: "flex",
      justifyContent: "flex-end"
    },
    arrowButton: {
      color: theme.palette.grey[800],
      "&:focus": {
        background: theme.palette.grey[100]
      }
    },
    collapse: {
      paddingLeft: "1rem"
    },
    selectField_2: {
      width: "100%",
      marginTop: "0.5rem"
    },
    circularProgressWrapper: {
      display: "grid",
      placeItems: "center",
      marginTop: "0.5rem"
    },
    container: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "100%",
      overflow: "auto",
      padding: "0 1rem"
    },
    bottomButtonsWrapper: {
      padding: "1rem 1rem 0.5rem"
    }
  };
});
var Categories = function Categories(props) {
  var classes = useStyle();
  var filteredCategories = props.filteredCategories,
    categories = props.categories,
    handleApplyClick = props.handleApplyClick,
    handleCancelClick = props.handleCancelClick,
    setFilteredCategories = props.setFilteredCategories;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    openedCollapses = _useState2[0],
    setOpenedCollapses = _useState2[1];
  var handleCategoriesCheckboxChange = (0, _react.useCallback)(function (event) {
    var newValues = event.target.value.split(",");
    var newCheckedCategories = [].concat(_toConsumableArray(filteredCategories), _toConsumableArray(newValues)).filter(function (value) {
      return !(filteredCategories.includes(value) && newValues.includes(value));
    });
    setFilteredCategories(newCheckedCategories);
  }, [setFilteredCategories, filteredCategories]);
  var getChildren = (0, _react.useCallback)(function (category) {
    // This function is used to all of the categories with their children recursively
    var returnedChildren = [];
    if (category !== null && category !== void 0 && category.sub_categories) {
      // Then we loop through its children
      category.sub_categories.forEach(function (item) {
        // We need to get the category from all the categories, because in the subCategories
        // we only have the id and name
        var currentCategory = categories.find(function (elem) {
          return elem.id === +item.id;
        });
        // Then we push our category to our array
        currentCategory && returnedChildren.push(_objectSpread(_objectSpread({}, currentCategory), {}, {
          // We apply our recursivity on the subCategories to get all of its
          // child categories and so on.
          sub_categories: getChildren(currentCategory)
        }));
      });
    }
    return returnedChildren;
  }, [categories]);
  var organizedCategories = (0, _react.useMemo)(function () {
    var mainCategories = categories.filter(function (item) {
      return !item.parent_category;
    });
    if (mainCategories !== null && mainCategories !== void 0 && mainCategories.length) {
      return mainCategories.map(function (category) {
        return _objectSpread(_objectSpread({}, category), {}, {
          sub_categories: getChildren(category)
        });
      });
    }
    return categories;
  }, [getChildren, categories]);
  var checkIfCategoryChecked = (0, _react.useCallback)(function (id) {
    return filteredCategories.includes(String(id));
  }, [filteredCategories]);
  var handleClick = (0, _react.useCallback)(function (index) {
    var selectedIndex = openedCollapses.indexOf(index);
    var newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(openedCollapses, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(openedCollapses.slice(1));
    } else if (selectedIndex === openedCollapses.length - 1) {
      newSelected = newSelected.concat(openedCollapses.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(openedCollapses.slice(0, selectedIndex), openedCollapses.slice(selectedIndex + 1));
    }
    setOpenedCollapses(newSelected);
  }, [openedCollapses]);

  // This function returns an array of all subcategories' ids of a given category and their subcategories and their their subcategories and so on (goes deep down)
  var subCategoriesIdsOfAll = (0, _react.useRef)({});
  var getSubCategoriesIds = (0, _react.useCallback)(function (category) {
    var subCategoriesId = [];
    (function loopThroughSubCategoriesAndGetAllIds(sub_categories) {
      var _iterator = _createForOfIteratorHelper(sub_categories),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var subCategory = _step.value;
          subCategoriesId.push(subCategory.id);
          if (subCategory.sub_categories.length) {
            loopThroughSubCategoriesAndGetAllIds(subCategory.sub_categories);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    })(category.sub_categories);
    subCategoriesIdsOfAll.current[category.id] = subCategoriesId;
    return subCategoriesId;
  }, []);

  // This function gets all subcategories' Ids of a given category (one level deep)
  var getAllIds = (0, _react.useCallback)(function (categories, ids) {
    categories.forEach(function (category) {
      var _category$sub_categor;
      if ((_category$sub_categor = category.sub_categories) !== null && _category$sub_categor !== void 0 && _category$sub_categor.length) {
        var subCategoriesId = category.sub_categories.map(function (sub) {
          return sub.id;
        });
        ids[category.id] = subCategoriesId;
        getAllIds(category.sub_categories, ids);
      }
    });
  }, []);
  var allSubCategoriesIds = (0, _react.useMemo)(function () {
    var ids = {};
    getAllIds(organizedCategories, ids);
    return ids;
  }, [organizedCategories, getAllIds]);
  var showCategoryFields = (0, _react.useCallback)(function (mainCategories) {
    return mainCategories.map(function (category, index) {
      var _category$sub_categor2;
      if (((_category$sub_categor2 = category.sub_categories) === null || _category$sub_categor2 === void 0 ? void 0 : _category$sub_categor2.length) > 0) {
        var _category$breadcrumb, _allSubCategoriesIds$, _category$parent_cate;
        var parentsIds = (_category$breadcrumb = category.breadcrumb) === null || _category$breadcrumb === void 0 ? void 0 : _category$breadcrumb.map(function (bread) {
          return bread.id;
        });
        var areParentsChecked = parentsIds.some(function (id) {
          return checkIfCategoryChecked(id);
        });
        var siblingsIds = (_allSubCategoriesIds$ = allSubCategoriesIds[(_category$parent_cate = category.parent_category) === null || _category$parent_cate === void 0 ? void 0 : _category$parent_cate.id]) === null || _allSubCategoriesIds$ === void 0 ? void 0 : _allSubCategoriesIds$.filter(function (id) {
          return id !== category.id;
        });
        var subCategoriesIds = subCategoriesIdsOfAll.current[category.id] || getSubCategoriesIds(category);
        var isCategoryChecked = checkIfCategoryChecked(category.id) || areParentsChecked;
        var checkboxValues = isCategoryChecked ? areParentsChecked ? [].concat(_toConsumableArray(parentsIds.filter(function (id) {
          return checkIfCategoryChecked(id);
        })), _toConsumableArray(siblingsIds)) : category.id : subCategoriesIds.some(function (id) {
          return checkIfCategoryChecked(id);
        }) ? [].concat(_toConsumableArray(subCategoriesIds.filter(function (id) {
          return checkIfCategoryChecked(id);
        })), [category.id]) : category.id;
        var isOpened = openedCollapses.includes(category.id);
        return /*#__PURE__*/_react.default.createElement("div", {
          key: index
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: classes.categoryFieldWrapper
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: classes.categoryField
        }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
          className: classes.formControlLabel_2,
          control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
            name: _config.CATEGORY_FILTER_QUERY,
            value: checkboxValues,
            onChange: handleCategoriesCheckboxChange,
            checked: isCategoryChecked
          }),
          label: /*#__PURE__*/_react.default.createElement(_core.Typography, null, category.name)
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: classes.arrowButtonWrapper
        }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
          onClick: function onClick() {
            return handleClick(category.id);
          },
          className: classes.arrowButton
        }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, !isOpened ? "keyboard_arrow_down" : "keyboard_arrow_up")))), /*#__PURE__*/_react.default.createElement(_core.Collapse, {
          className: classes.collapse,
          in: isOpened
        }, isOpened && category.sub_categories.map(function (childCategory, index) {
          var _childCategory$breadc, _childCategory$sub_ca;
          var isChecked = checkIfCategoryChecked(childCategory.id) || isCategoryChecked;
          var parentsIds = ((_childCategory$breadc = childCategory.breadcrumb) === null || _childCategory$breadc === void 0 ? void 0 : _childCategory$breadc.map(function (bread) {
            return bread.id;
          })) || [];
          var siblingsIds = category.sub_categories.map(function (sub) {
            return sub.id;
          });
          if (((_childCategory$sub_ca = childCategory.sub_categories) === null || _childCategory$sub_ca === void 0 ? void 0 : _childCategory$sub_ca.length) > 0) {
            return showCategoryFields([childCategory]);
          }
          var checkboxValues = isChecked ? isCategoryChecked ? [].concat(_toConsumableArray(parentsIds.filter(function (id) {
            return checkIfCategoryChecked(id);
          })), _toConsumableArray(siblingsIds.filter(function (id) {
            return id !== childCategory.id;
          }))) : childCategory.id : childCategory.id;
          return /*#__PURE__*/_react.default.createElement("div", {
            key: index
          }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
            className: classes.formControlLabel_1,
            control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
              name: _config.CATEGORY_FILTER_QUERY,
              value: checkboxValues,
              onChange: handleCategoriesCheckboxChange,
              checked: isChecked
            }),
            label: /*#__PURE__*/_react.default.createElement(_core.Typography, null, childCategory.name)
          }));
        })));
      } else {
        var isChecked = checkIfCategoryChecked(category.id);
        return /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
          className: classes.formControlLabel_2,
          key: index,
          control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
            name: _config.CATEGORY_FILTER_QUERY,
            value: category.id,
            onChange: handleCategoriesCheckboxChange,
            checked: isChecked
          }),
          label: /*#__PURE__*/_react.default.createElement(_core.Typography, null, category.name)
        });
      }
    });
  }, [allSubCategoriesIds, subCategoriesIdsOfAll, checkIfCategoryChecked, getSubCategoriesIds, handleCategoriesCheckboxChange, handleClick, openedCollapses, classes]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, showCategoryFields(organizedCategories)), /*#__PURE__*/_react.default.createElement(_ApplyAndCancelButtons.ApplyAndCancelButtons, {
    onCancel: handleCancelClick,
    onApply: handleApplyClick,
    className: classes.bottomButtonsWrapper
  }));
};
exports.Categories = Categories;
var CategoryOfProductFilterField = /*#__PURE__*/_react.default.forwardRef(function (_ref, handleAddFilterRef) {
  var appliedFilter = _ref.appliedFilter,
    allFilters = _ref.allFilters,
    setAllFilters = _ref.setAllFilters,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyle();
  // this state is used to store the value of the selected category that we want to filter by
  var _useState3 = (0, _react.useState)(appliedFilter[_config.CATEGORY_FILTER_QUERY] ? Array.isArray(appliedFilter[_config.CATEGORY_FILTER_QUERY]) ? appliedFilter[_config.CATEGORY_FILTER_QUERY] : [appliedFilter[_config.CATEGORY_FILTER_QUERY]] : []),
    _useState4 = _slicedToArray(_useState3, 2),
    filteredCategories = _useState4[0],
    setFilteredCategories = _useState4[1];
  var previousValues = (0, _react.useRef)(filteredCategories);
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return {
        categories: state.categoryOfProductReducer.categories,
        fetchCategoriesInProgress: state.categoryOfProductReducer.fetchCategoriesInProgress
      };
    }),
    categories = _useSelector.categories,
    fetchCategoriesInProgress = _useSelector.fetchCategoriesInProgress;
  var handleAddFilter = function handleAddFilter() {
    // we want to show filtered categories on the UI like this:
    // Categories: lave-linge, lave-linge-2, ...
    var categoriesNames = filteredCategories.map(function (categoryId) {
      return categories.find(function (category) {
        return category.id === +categoryId;
      }).name;
    });
    var categoriesNamesLabel = "".concat(props.intl.formatMessage({
      id: "Catégories:",
      defaultMessage: "Catégories:"
    }), " ").concat(categoriesNames.join(", "));
    var filterName = _config.CATEGORY_FILTER_QUERY;
    var filterValue = _toConsumableArray(filteredCategories);
    return (0, _TableFilters.setFilter)({
      allFilters: allFilters,
      setAllFilters: setAllFilters,
      columnName: "categories",
      filterLabel: categoriesNamesLabel,
      filterName: filterName,
      filterValue: filterValue
    });
  };
  var handleApplyClick = function handleApplyClick() {
    previousValues.current = filteredCategories;
    closePopup();
  };
  var handleCancelClick = function handleCancelClick() {
    setFilteredCategories(previousValues.current);
    closePopup();
  };
  var closePopup = function closePopup() {
    document.getElementById("menu-".concat(_config.CATEGORY_FILTER_QUERY)).firstChild.click();
  };
  handleAddFilterRef.current = handleAddFilter;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fetchCategoriesInProgress ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.circularProgressWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, null)) : /*#__PURE__*/_react.default.createElement(_core.Select, {
    className: classes.selectField_2,
    name: _config.CATEGORY_FILTER_QUERY,
    variant: "outlined",
    renderValue: function renderValue() {
      return filteredCategories.length ? "Categories: ".concat(filteredCategories.join(", ")) : "Categories";
    },
    SelectDisplayProps: {
      style: {
        whiteSpace: "pre-wrap"
      }
    },
    onClose: handleApplyClick,
    displayEmpty: true
  }, /*#__PURE__*/_react.default.createElement(Categories, {
    handleApplyClick: handleApplyClick,
    handleCancelClick: handleCancelClick,
    categories: categories,
    filteredCategories: filteredCategories,
    setFilteredCategories: setFilteredCategories
  })), allFilters.length < 5 && /*#__PURE__*/_react.default.createElement(_AddFilterButton.AddFilterButton, {
    isDisabled: !filteredCategories.length,
    handleClick: handleAddFilter
  }));
});
exports.CategoryOfProductFilterField = CategoryOfProductFilterField;